import Vue from "vue";
import Router from "vue-router";
import App from "@/views/App.vue";
Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/:locationCode",
      name: "clientViewerId",
      meta: {
        layout: "MobileLayout",
      },
      component: App,
    },
    {
      path: "/",
      name: "clientViewer",
      meta: {
        layout: "MobileLayout",
      },
      component: App,
    },
  ],
});
